import { Inject, Injectable } from '@angular/core'
import { IFacet, IQueryParams, mapFacetsObjectToInterface } from '../shared/models/facet.interface'
import { LOGGER_SERVICE } from '../logger/logger.config'
import { LoggerService } from '../logger/logger.interface'
import { FacetDisplayNames } from '../shared/facets/models'

@Injectable({
  providedIn: 'root'
})
export class VerticalSearchService {
  constructor(@Inject(LOGGER_SERVICE) private readonly logger: LoggerService) {}

  public parseFacets(queryParams: IQueryParams): IQueryParams {
    if (queryParams.facets) {
      try {
        return {
          ...queryParams,
          facets: JSON.parse(queryParams.facets)
        }
      } catch (error) {
        this.logger.error('parseFacets: unable to parse facets input', error)
        return {
          ...queryParams,
          facets: undefined
        }
      }
    } else {
      return queryParams
    }
  }

  public buildFacetsObject(
    facets: Record<string, ReadonlyArray<IFacet>>,
    facetDisplayNames: FacetDisplayNames
  ): ReadonlyArray<IFacet> {
    if (!facets) this.logger.error('mapFacetsObjectToInterface: invalid input')
    return mapFacetsObjectToInterface(facets, facetDisplayNames)
  }
}
